import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from "react";
import { useStatementsByPartyIdQuery, useFinanceSummaryQuery, } from "generated/generated-models";
import { CDate } from "../common/CapitalDate";
import { Autocomplete, Box, FormControl, Link, Paper, TextField, } from "@mui/material";
import { DataGridPro, GridLogicOperator, } from "@mui/x-data-grid-pro";
import { CError } from "app/common/CError";
import { Loading } from "app/lib/components/Loading";
import { useMediaQuery } from "@mui/material";
import { useParams } from "react-router-dom";
import { DownloadLink } from "app/components/DownloadLink";
import NoRowsOverlay from "app/components/NoRowsOverlay";
const StatementsListForParty = () => {
    const { data: dataStatements, loading: loadingStatements, error: errorStatements, } = useStatementsByPartyIdQuery();
    const { data: dataAccounts, loading: loadingAccounts, error: errorAccounts, } = useFinanceSummaryQuery();
    const statementByPartyId = dataStatements?.statementsByPartyId?.filter((dt) => dt?.AccountNumber);
    const accountsByPartyId = dataAccounts?.financeSummary?.Instruments?.flatMap((instrument) => instrument?.Accounts);
    const [selectedAccountNumber, setSelectedAccountNumber] = React.useState("");
    const [filteredData, setFilteredData] = React.useState([]);
    const [listAccounts, setListAccounts] = React.useState([]);
    const widthMed = useMediaQuery("(max-width: 575px)");
    const widthSml = useMediaQuery("(max-width: 450px)");
    const { number } = useParams();
    React.useEffect(() => {
        if (!loadingStatements && dataStatements) {
            if (number) {
                const filterStatements = statementByPartyId
                    .sort((a, b) => (a.CreatedOn > b.CreatedOn ? -1 : 1))
                    .filter((dt) => dt?.AccountNumber === number)
                    .map((item) => item);
                setFilteredData(filterStatements);
            }
            else {
                const filteredStatementData = statementByPartyId
                    .sort((a, b) => (a.CreatedOn > b.CreatedOn ? -1 : 1))
                    .map((item) => item);
                setFilteredData(filteredStatementData);
            }
        }
        if (!loadingAccounts && dataAccounts) {
            const accountNumber = accountsByPartyId?.map((account) => account?.Number);
            const accountNumberObject = accountNumber.map((item) => item);
            setListAccounts(accountNumberObject);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loadingStatements, dataStatements, loadingAccounts, dataAccounts]);
    if (loadingStatements || loadingAccounts) {
        return _jsx(Loading, {});
    }
    if (errorStatements || errorAccounts) {
        return (_jsx("section", { className: "sub-wrap", children: _jsx(CError, { error: "Could not retrieve account statements." }) }));
    }
    const handleAccountChange = (_event, value) => {
        if (value !== null || undefined || "") {
            const filterStatements = statementByPartyId
                .sort((a, b) => (a.CreatedOn > b.CreatedOn ? -1 : 1))
                .filter((dt) => dt?.AccountNumber === value)
                .map((item) => item);
            setFilteredData(filterStatements);
        }
        else {
            setFilteredData(statementByPartyId
                .sort((a, b) => (a.CreatedOn > b.CreatedOn ? -1 : 1))
                .map((item) => item));
        }
    };
    const rows = filteredData;
    const columns = [
        {
            field: "InstrumentId",
            headerName: "Instrument",
            width: 0,
            filterable: false,
        },
        {
            field: "AdHoc",
            headerName: "",
            width: 0,
            filterable: false,
        },
        {
            field: "Number",
            headerName: "Statement",
            minWidth: 120,
            flex: 2,
            renderCell: (params) => params.row.AdHoc === true ? (_jsxs(_Fragment, { children: [_jsx(Link, { href: `/api/v4/CustomerPortal/Document/${params.row.FileId}/Download`, target: "_blank", rel: "noopener noreferrer", children: params.value }), _jsx("span", { className: "adhoc", children: "Adhoc" })] })) : (_jsx(Link, { href: `/api/v4/CustomerPortal/Document/${params.row.FileId}/Download`, target: "_blank", rel: "noopener noreferrer", children: params.value })),
        },
        {
            field: "AccountNumber",
            headerName: "Account",
            minWidth: 110,
            flex: 2,
        },
        {
            field: "PeriodFrom",
            headerName: "From",
            minWidth: 120,
            flex: 2,
            renderCell: (params) => _jsx(CDate, { date: params.value }),
        },
        {
            field: "PeriodTo",
            headerName: "To",
            minWidth: 120,
            flex: 2,
            renderCell: (params) => _jsx(CDate, { date: params.value }),
        },
        {
            field: "FileId",
            headerName: "",
            align: "center",
            headerAlign: "center",
            minWidth: 40,
            flex: 1,
            filterable: false,
            renderCell: (params) => (_jsx(DownloadLink, { href: `/api/v4/CustomerPortal/Document/${params.value}/Download` })),
        },
    ];
    return (_jsxs("section", { className: "sub-wrap statements-list", children: [_jsx("div", { className: "list-header", children: _jsx("h2", { children: "Statements" }) }), _jsx(Box, { children: _jsxs("div", { className: "statement-container", style: { height: 700, width: "100%" }, children: [_jsx(Box, { sx: { flex: "1 1 100%" }, className: "filterContainer", children: _jsx(FormControl, { sx: { width: 220, mr: 3 }, size: "small", className: "filterControl", children: _jsx(Autocomplete, { id: "filtered-account-outlined", size: "small", options: listAccounts, getOptionLabel: (option) => option ? option : "", onChange: handleAccountChange, inputValue: selectedAccountNumber, defaultValue: number ? number : "", onInputChange: (_event, newSelectedAccountNumber) => {
                                        setSelectedAccountNumber(newSelectedAccountNumber);
                                    }, PaperComponent: ({ children }) => (_jsx(Paper, { style: { fontSize: "0.9rem" }, children: children })), renderInput: (params) => (_jsx(TextField, { ...params, label: "Account" })) }) }) }), _jsx(DataGridPro, { className: "custom-grid", columns: columns, rows: rows, getRowId: (r) => r.Id, pagination: true, pageSizeOptions: [10, 25, 50], columnVisibilityModel: {
                                InstrumentId: false,
                                AdHoc: false,
                                PeriodFrom: !widthMed,
                                FileId: !widthSml,
                            }, initialState: {
                                pagination: {
                                    paginationModel: { pageSize: 10 },
                                },
                            }, slots: {
                                noRowsOverlay: () => (_jsx(NoRowsOverlay, { children: "There are currently no statements for this account." })),
                            }, disableColumnSelector: true, slotProps: {
                                filterPanel: {
                                    logicOperators: [GridLogicOperator.And],
                                    columnsSort: "asc",
                                    filterFormProps: {
                                        logicOperatorInputProps: {
                                            variant: "outlined",
                                            size: "small",
                                        },
                                        columnInputProps: {
                                            variant: "outlined",
                                            size: "small",
                                            sx: { mt: "auto" },
                                        },
                                        operatorInputProps: {
                                            variant: "outlined",
                                            size: "small",
                                            sx: { mt: "auto" },
                                        },
                                        deleteIconProps: {
                                            sx: {
                                                "& .MuiSvgIcon-root": {
                                                    color: "#d32f2f",
                                                },
                                            },
                                        },
                                    },
                                    sx: {
                                        "& .MuiDataGrid-filterForm": { p: 2 },
                                        "& .MuiDataGrid-filterForm:nth-child(even)": {
                                            backgroundColor: (theme) => theme.palette.mode === "dark"
                                                ? "#444"
                                                : "#f5f5f5",
                                        },
                                        "& .MuiDataGrid-filterFormLinkOperatorInput": { mr: 2 },
                                        "& .MuiDataGrid-filterFormColumnInput": {
                                            mr: 2,
                                            width: 150,
                                        },
                                        "& .MuiDataGrid-filterFormOperatorInput": {
                                            mr: 2,
                                        },
                                        "& .MuiDataGrid-filterFormValueInput": {
                                            width: 200,
                                        },
                                    },
                                },
                            } })] }) })] }));
};
export default StatementsListForParty;
